import { useRef } from 'react';
import './OrderItemNotConsigned.css';
import { ApiOrderItem } from '../../types';
import { Link } from 'react-router-dom';
import { Img } from '../Img/Img';
import { useTranslation } from '../../i18n/i18n';

export const OrderItemNotConsigned = ({ orderItem, left }: { orderItem: ApiOrderItem; left: number }): JSX.Element => {
	const imgRef = useRef<HTMLImageElement>(null);
	const t = {
		...useTranslation().orderFulfillment,
		...useTranslation().product,
	};

	const { product } = orderItem;

	return (
		<div className="order-item-wrapper">
			<div className="row">
				<div className="product-image">
					<Link to={'/-p-' + product.id}>
						<Img ref={imgRef} src={orderItem.image} width={50} height={50} alt={product.name} />
					</Link>
				</div>
				<div className="product-details-wrapper">
					<div className="product-link">
						<Link to={'/-p-' + product.id}>{product.name}</Link>
					</div>
					<div className="article-number">
						<dl>
							<dt>{t.articleNumber}:</dt>
							<dd>{product.displayId}</dd>
						</dl>
					</div>
					<div className="stocked">
						<dl>
							<dt>{t.quantityLeft}</dt>
							<dd>
								<span>{left}</span>
							</dd>
						</dl>
					</div>
				</div>
			</div>
		</div>
	);
};
